<template>
  <slot v-if="!hideBranding" />
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

const { hideBranding } = storeToRefs(useViewerItemStore());
</script>
